import type { GetSecondLineImpactRatingByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetSecondLineImpactRatingByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetSecondLineImpactRatingByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetSecondLineImpactRatingByIdArgs = {
  id: string;
};

export const useGetSecondLineImpactRatingById = createQueryHook<
  UseGetSecondLineImpactRatingByIdArgs,
  GetSecondLineImpactRatingByIdResponseRow[],
  GetSecondLineImpactRatingByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.impactRating.secondLineImpactRatingById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ impact_second_line_rating: data }),
  graphqlDocument: GetSecondLineImpactRatingByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
